console.log("CLEAN BUNDLE JS LOADED");

// =====================
// STATE
// =====================
window.bundle = window.bundle || [];
function getDiscountRate(count) {
  if (count >= 6) return 0.15;
  if (count >= 3) return 0.10;
  return 0;
}

function removeItem(index) {
  window.bundle.splice(index, 1);
  render();
}
// =====================
// INIT
// =====================
document.addEventListener("DOMContentLoaded", () => {

  document.addEventListener("click", handleClick);

  const cartBtn = document.getElementById("add-bundle-to-cart");
  if (cartBtn) {
    cartBtn.addEventListener("click", addBundleToCart);
  }

  render();
});


// =====================
// HANDLE CLICK (PRODUCT TOGGLE)
// =====================
function handleClick(e) {

  const btn = e.target.closest(".add-btn");

  if (btn) {
    toggleItem(btn);
    return;
  }

  const card = e.target.closest(".bundle-card");

  if (card) {
    const fakeBtn = card.querySelector(".add-btn");
    if (fakeBtn) toggleItem(fakeBtn);
  }
}
function toggleItem(el) {

  const id = String(el.dataset.variantId);

  // each click = new entry (no merging, no qty)
  window.bundle.push({
    id,
    title: el.dataset.title,
    image: el.dataset.image,
    price: Number(el.dataset.price),
    comparePrice: Number(el.dataset.comparePrice || el.dataset.price)
  });

  render();
}

// =====================
// RENDER EVERYTHING
// =====================
function render() {

  renderSidebar();
// allow DOM to finish painting before syncing buttons
  requestAnimationFrame(() => {
    syncButtons();
  });
  updateMessage();
  updateSlots();
  updatePrices(); 
}


// =====================
// SIDEBAR RENDER
// =====================
function renderSidebar() {

  const container = document.getElementById("bundle-items");
  if (!container) return;

  container.innerHTML = "";

  window.bundle.forEach((item, index) => {

    const el = document.createElement("div");
    el.className = "bundle-item";

    el.innerHTML = `
      <div class="bundle-item-inner" onclick="removeItem(${index})">
        <img src="${item.image}" />
        <span class="remove-dot">×</span>
      </div>
    `;

    container.appendChild(el);
  });
}


// =====================
// SYNC BUTTON STATES
// =====================
function syncButtons() {

  const buttons = document.querySelectorAll(".add-btn");
  if (!buttons.length) return;

  buttons.forEach(btn => {
    const id = btn.dataset.variantId;
    if (!id) return;

    const selected = window.bundle.some(i => i.id === id);

    btn.classList.toggle("selected", selected);
    btn.textContent = selected ? "✓" : "+";

    const card = btn.closest(".bundle-card");
    if (card) {
      card.classList.toggle("selected", selected);
    }
  });
}


// =====================
// REMOVE ITEM
// =====================
window.removeItem = function(index) {
  window.bundle.splice(index, 1);
  render();
};


// =====================
// MILESTONE TEXT
// =====================
function updateMessage() {

  const msg = document.getElementById("bundle-message");
  if (!msg) return;

  const count = window.bundle.length;

  if (count === 0) {
    msg.textContent = "Start building your bundle";
  } else if (count < 3) {
    msg.textContent = "Add 3 items to unlock 10%";
  } else if (count < 6) {
    msg.textContent = "✦ 10% unlocked ✦";
  } else {
    msg.textContent = "✦ 15% unlocked ✦";
  }
}


// =====================
// SLOT INDICATOR
// =====================
function updateSlots() {

  const slots = document.querySelectorAll(".bundle-slots .slot");

  slots.forEach((slot, i) => {
    slot.classList.toggle("filled", i < window.bundle.length);
  });
}


// =====================
// ADD TO CART (NO REDIRECT)
// =====================
function addBundleToCart() {

  if (!window.bundle || !window.bundle.length) return;

  const items = window.bundle.map(item => ({
    id: Number(item.id),
    quantity: 1
  }));

  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ items })
  })
  .then(res => {
    if (!res.ok) throw res;
    return res.json();
  })
  .then(() => {

    // support BOTH button types safely
    const btn =
      document.getElementById("add-bundle-to-cart") ||
      document.querySelector(".add-btn");

    if (btn) {
      const original = btn.textContent;
      btn.textContent = "Added ✓";

      setTimeout(() => {
        btn.textContent = original;
      }, 1200);
    }

  })
  .catch(err => {
    console.error("Cart error:", err);
    alert("Could not add bundle to cart");
  });
}


// =====================
// MOBILE SIDEBAR MODE
// =====================
function updateMobileSidebarMode() {

  const sidebar = document.querySelector(".bundle-sidebar");
  if (!sidebar) return;

  if (window.innerWidth <= 768) {
    sidebar.classList.add("compact");
  } else {
    sidebar.classList.remove("compact");
  }
}

function updatePrices() {

  const itemCount = window.bundle.length;

  const discount = getDiscountRate(itemCount);

  let totalCents = 0;

  window.bundle.forEach(item => {
    totalCents += Number(item.price || 0);
  });

  const compareCents = totalCents; // original full price
  const discountedCents = totalCents * (1 - discount);

  const compareEl = document.getElementById("bundle-compare");
  const totalEl = document.getElementById("bundle-total");

  if (compareEl) {
    compareEl.textContent = `$${(compareCents / 100).toFixed(2)}`;
  }

  if (totalEl) {
    totalEl.textContent = `$${(discountedCents / 100).toFixed(2)}`;
  }
}

// =====================
// SAFE INIT (FIXES RENDER TIMING ISSUES)
// =====================
function initUIFixes() {
  updateMobileSidebarMode();
}

// run after DOM
document.addEventListener("DOMContentLoaded", initUIFixes);

// run on resize
window.addEventListener("resize", updateMobileSidebarMode);

// run after full load (IMPORTANT FIX)
window.addEventListener("load", updateMobileSidebarMode);